<template>
    <div class="d-flex align-items-center w-100">
        <div>
            <img class="round" :src="user.avatar !== null ? user.avatar.url :  '/images/avatar.png'"
                             alt="avatar"
                             height=25
                             width="25"/>
        </div>
        <span class="font-weight-bold ml-05 mr-05 mb-0">{{ user.first_name }} {{ user.last_name }}</span>
        <span v-for="badge in user.badges">
            <img :src="badge.image" style="margin-top: -3px;  height: 12px;" data-toggle="tooltip" alt="Badge Image"
                                     data-placement="bottom"
                                     :title="badge.name"/>
        </span>

        <img :src="user.user_badge_image.url" style="margin-top: -3px;  height: 12px;" data-toggle="tooltip" data-placement="bottom" alt="Badge Image"
                         :title="user.user_badge_name" v-if="user.user_badge_name !== null && user.user_badge_icon !== null"/>

        <div class="ml-auto">
            <div class="ml-1">
                <span v-if="!isInvited">
                    <button class="btn-sm btn-outline-primary" @click.prevent="invite()">{{ __('group.form.buttons.invite') }}</button>
                </span>
                <span v-else>
                    <button class="btn-sm btn-outline-danger" @click.prevent="removeInvite()">{{ __('group.form.buttons.delete_invite') }}</button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UserInviteCard",
    props: ['user', 'type', 'slug'],
    data() {
        return {
            isInvited: this.user.invite_pending,
        }
    },
    methods: {
        invite() {
            axios
                .post(`/member/${this.type}/${this.slug}/invite/${this.user.username}`)
                .then((response) => {
                    let flash_data = {
                        'message': response.data.message,
                        'level': response.data.status
                    }
                    flash(flash_data);
                    this.isInvited = true;
                })
                .catch((error) => {
                    let flash_data = {
                        'message': 'An Error Occurred',
                        'level': 'danger'
                    }
                    flash(flash_data);
                })
        },
        removeInvite() {
            axios
                .delete(`/member/${this.type}/${this.slug}/invite/${this.user.username}`)
                .then((response) => {
                    let flash_data = {
                        'message': response.data.message,
                        'level': response.data.status
                    }
                    flash(flash_data);
                    this.isInvited = false;
                })
                .catch((error) => {
                    let flash_data = {
                        'message': 'An Error Occurred',
                        'level': 'danger'
                    }
                    flash(flash_data);
                })
        },
    },
}
</script>

<style scoped>

</style>
